import React from 'react';
import styled from 'styled-components';
import { coursesData } from '../../data/coursesData';
import { colors } from '../../styles/variables';

const Section = styled.section`
  background: #fff;
  padding: 48px 24px 32px;
  text-align: center;
`;

const Container = styled.div`
  max-width: 900px;
  margin: 0 auto;
`;

const Title = styled.h3`
  font-size: 28px;
  font-weight: 700;
  color: ${colors.primary};
  margin-bottom: 32px;
`;

const ReviewList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  justify-content: center;
`;

const ReviewCard = styled.div`
  background: ${colors.white};
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  padding: 24px 20px 20px 20px;
  min-width: 260px;
  max-width: 320px;
  flex: 1 1 260px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const Stars = styled.div`
  color: #FFD600;
  font-size: 20px;
  margin-bottom: 12px;
`;

const ReviewText = styled.p`
  font-size: 16px;
  color: ${colors.primary};
  margin-bottom: 16px;
  text-align: left;
`;

const Reviewer = styled.div`
  font-size: 15px;
  color: ${colors.secondary};
  font-weight: 500;
  text-align: left;
`;

function getRandomReviews(allReviews, count = 3) {
  const shuffled = allReviews.sort(() => 0.5 - Math.random());
  return shuffled.slice(0, count);
}

function maskName(name) {
  return name.replace(/0/g, '〇');
}

const ReviewSection = () => {
  // 모든 과목의 리뷰를 합침
  const allReviews = coursesData.flatMap(course => course.reviews || []);
  const reviews = getRandomReviews(allReviews, 3);

  return (
    <Section>
      <Container>
        <Title>실제 수강생들의 생생한 후기</Title>
        <ReviewList>
          {reviews.map((review, idx) => (
            <ReviewCard key={idx}>
              <Stars>{'★★★★★'}</Stars>
              <ReviewText>"{review.text}"</ReviewText>
              <Reviewer>- {maskName(review.name)}</Reviewer>
            </ReviewCard>
          ))}
        </ReviewList>
      </Container>
    </Section>
  );
};

export default ReviewSection; 